/**
 * PubSub topics for application-wide event communication
 * Each topic is a unique symbol that can be used to publish and subscribe to events
 */

export const TRACE_AC_CALL = Symbol('TRACE_AC_CALL');
export const CUSTOMER_ID_CHANGED = Symbol('CUSTOMER_ID_CHANGED');

export const DISPLAY_VARIATION_DETAILS = Symbol('DISPLAY_VARIATION_DETAILS');
export const CLOSE_VARIATION_DETAILS = Symbol('CLOSE_VARIATION_DETAILS');

export const SCROLL_TO_SELECTED_GENERATION_MODE = Symbol('SCROLL_TO_SELECTED_GENERATION_MODE');
export const OPEN_GENERATION_PANEL_MENU = Symbol('OPEN_GENERATION_PANEL_MENU');

/**
 * Type definitions for pubsub topic data
 */
export interface PubSubTopics {
  [TRACE_AC_CALL]: void;
  [CUSTOMER_ID_CHANGED]: { customerId: string };
  [DISPLAY_VARIATION_DETAILS]: void;
  [CLOSE_VARIATION_DETAILS]: void;
  [SCROLL_TO_SELECTED_GENERATION_MODE]: void;
  [OPEN_GENERATION_PANEL_MENU]: { openedMenuType: string };
}

/**
 * Union type of all available pubsub topics
 */
export type PubSubTopic = keyof PubSubTopics;

/**
 * Type for pubsub topic data based on the topic
 */
export type PubSubData<T extends PubSubTopic> = PubSubTopics[T];
